import { render, staticRenderFns } from "./description.vue?vue&type=template&id=20b24506&scoped=true"
import script from "./description.vue?vue&type=script&lang=ts"
export * from "./description.vue?vue&type=script&lang=ts"
import style0 from "./description.vue?vue&type=style&index=0&id=20b24506&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b24506",
  null
  
)

export default component.exports